/**
 * Created by fworld on 2019/9/20.
 */

import research from "./research";
import delivery from "./delivery";
import device from "./device";
export default {
    path: '/factory',
    name: 'factory',
    component: () => import('@/layout/main'),
    redirect: {name: 'factory.index'},
    children: [
        {...research},
        {...delivery},
        {...device},
    ]
}
